module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('image-upload-field', {
    attrs: {
      "api-base": _vm.apiBase,
      "images": _vm.expenseUpload,
      "multi": false,
      "upload-msg": "+ UPLOAD EXPENSE RECEIPT",
      "upload-type": "expense",
      "no-thumbs": true
    },
    on: {
      "imageListChanged": _vm.saveUpload
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('th', [_vm._v("Date Uploaded")]), _vm._v(" "), (_vm.ownerType == 'client') ? _c('th', [_vm._v("Location")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("View")]), _vm._v(" "), _c('th')]), _vm._v(" "), _c('tbody', _vm._l((_vm.expensesWithTokens), function(expense) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(expense.updated_at))]), _vm._v(" "), (_vm.ownerType == 'client') ? _c('td', [_vm._v(_vm._s(expense.locations.location_name))]) : _vm._e(), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": expense.receipt_link,
        "target": "_blank"
      }
    }, [_vm._v("View Receipt")])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          _vm.deleteExpense(expense)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])
  }))]), _vm._v(" "), (_vm.confirmDialog.visible) ? _c('modal-dialog', {
    attrs: {
      "title": _vm.confirmDialog.title,
      "modal-visible": _vm.confirmDialog.visible,
      "confirm-button-text": _vm.confirmDialog.buttonText,
      "button-class": _vm.confirmDialog.buttonClass
    },
    on: {
      "confirm": function($event) {
        _vm.executeDeleteExpense(_vm.confirmDialog.parameters)
      },
      "closeModal": function($event) {
        _vm.confirmDialog.visible = false
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.confirmDialog.message) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.locationSelectDialog.visible) ? _c('modal-dialog', {
    attrs: {
      "title": "Set Client Location for Expense",
      "modal-visible": _vm.locationSelectDialog.visible,
      "confirm-button-text": "Save",
      "button-class": "btn-success"
    },
    on: {
      "confirm": _vm.postExpense,
      "closeModal": function($event) {
        _vm.locationSelectDialog.visible = false
      }
    }
  }, [_c('form-group', {
    attrs: {
      "label": "Client Location",
      "col-class": "col-md-4"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationSelectDialog.fields.location_id),
      expression: "locationSelectDialog.fields.location_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.locationSelectDialog.fields.location_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.locations), function(location) {
    return _c('option', {
      domProps: {
        "value": location.id
      }
    }, [_vm._v(_vm._s(location.location_name))])
  }))])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31c97457","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExpenseList.vue
// module id = 283
// module chunks = 0